import React, { useState, useEffect } from "react";
import axios from "axios";
import HotelEditForm from "./ManagerHotelEditForm"; // Move HotelEditForm to its own file
import { API_BASE } from "../../config/apiBase";

export default function HotelTab({ token }) {
  const [hotel, setHotel] = useState(null);
  const API = `${API_BASE}/manager/website`;

  useEffect(() => {
    const fetchHotel = async () => {
      try {
        const res = await axios.get(`${API}/hotel`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setHotel(res.data.data);
      } catch (err) {
        setHotel(null);
      }
    };
    fetchHotel();
  }, [token]);

  if (!hotel) return <div>Loading hotel info...</div>;

  return <HotelEditForm hotel={hotel} onSave={setHotel} auth={() => ({ headers: { Authorization: `Bearer ${token}` } })} />;
}
